import { makeStyles } from '@material-ui/core/styles'

const BRAND_NAVY = '#001C57'
const APP_BAR_HEIGHT = 64

export const useStyles = makeStyles(theme => ({
  logo: {
    display: 'block',
    width: '48px',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    borderBottom: '1px solid #E0E0E0',
    borderRadius: 0,
  },
  filler: {
    flexGrow: 1,
  },
  helpButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    fontSize: '0.875rem',
    fontWeight: 400,
    color: '#6B7C87',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    fontFamily: 'inherit',
    '&:hover': {
      color: BRAND_NAVY,
    },
  },
  helpButtonIcon: {
    fontSize: 20,
  },
  page: {
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
  },
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    zIndex: theme.zIndex.appBar - 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(2, 3),
    backgroundColor: '#FFFFFF',
    borderTop: '1px solid #E0E0E0',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: theme.spacing(2),
    },
  },
  footerCopyright: {
    fontSize: '0.75rem',
    lineHeight: 1.4,
    color: '#6B7C87',
    whiteSpace: 'nowrap',
  },
  footerLinks: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2.5),
    [theme.breakpoints.down('xs')]: {
      gap: theme.spacing(1.5),
    },
  },
  footerLink: {
    fontSize: '0.75rem',
    lineHeight: 1.4,
    color: '#6B7C87',
    fontWeight: 400,
    cursor: 'pointer',
    '&:hover': {
      color: BRAND_NAVY,
    },
  },
  footerLinkAccent: {
    fontSize: '0.75rem',
    lineHeight: 1.4,
    color: BRAND_NAVY,
    fontWeight: 700,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    fontFamily: 'inherit',
    '&:hover': {
      color: BRAND_NAVY,
    },
  },
  hero: {
    backgroundColor: '#001C57',
    marginTop: APP_BAR_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    minHeight: 260,
    padding: theme.spacing(6, 0),
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      minHeight: 220,
      padding: theme.spacing(5, 0),
    },
  },
  heroContent: {
    maxWidth: 720,
  },
  eyebrow: {
    color: '#EBF0F2',
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.1em',
    lineHeight: 1.4,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1.5),
  },
  title: {
    fontFamily: '"Source Serif Pro", serif',
    fontWeight: 700,
    fontSize: '3rem',
    lineHeight: 1.15,
    color: '#FFFFFF',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.25rem',
    },
  },
  heroSubtext: {
    color: 'rgba(255, 255, 255, 0.78)',
    fontSize: '1rem',
    lineHeight: 1.6,
    fontWeight: 400,
    maxWidth: 560,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9375rem',
    },
  },
  cardsSection: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(3),
    },
  },
}))
